import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, vShow as _vShow, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-page-type"]

import MetaHandler from '@/classes/MetaHandler';
import {
  defineComponent,
  shallowRef,
  computed,
  nextTick,
  reactive,
  watch,
  ref,
} from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import PageInterface from '@/interfaces/PageInterface';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasePage',
  props: {
    noFetch: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const route = useRoute();
const store = useStore();
const pageType = computed(() => route.meta.type);
const show = reactive({ value: false });
const slug = computed(() => route.params.pageSlug);
const isFirstFetch = ref(true);

const toTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

const fetch = () => {
  if (props.noFetch && isFirstFetch.value) {
    isFirstFetch.value = false;

    if (window.ioInitialPageData) {
      delete window.ioInitialPageData;
    }

    return;
  }

  const appContent = document.querySelector('#ioapp-content');

  if (isFirstFetch.value && appContent) {
    isFirstFetch.value = false;

    return;
  }

  if (appContent) {
    appContent.remove();
  }

  store.dispatch('page/fetch', {
    slug: slug.value,
    pageId: route.query.page_id,
    preview: route.query.preview === 'true',
    previewId: route.query.preview_id,
  });
};

watch(() => slug.value, () => {
  fetch();
}, {
  immediate: true,
});

const page = computed<PageInterface | null>(() => store.getters['page/page']);
const status = computed(() => store.getters['page/status']);
const pageContent = shallowRef();

const updateAdminBar = () => {
  const $wpAdminBarCustomizer = document.querySelector('#wp-admin-bar-customize > a');
  const $wpAdminBarEdit = document.querySelector('#wp-admin-bar-edit > a');

  if ($wpAdminBarCustomizer) {
    $wpAdminBarCustomizer.setAttribute('href', `/wp-admin/customize.php?url=${window.location.origin}${route.path}`);
  }

  if ($wpAdminBarEdit && page.value) {
    $wpAdminBarEdit.setAttribute('href', `/wp-admin/post.php?post=${page.value.id}&action=edit`);
    $wpAdminBarEdit.innerHTML = page.value.postType?.labels.edit_item || $wpAdminBarEdit.innerHTML;
  } else if (page.value && page.value.id) {
    const $wpAdminBarRoot = document.querySelector('#wp-admin-bar-root-default');

    if ($wpAdminBarRoot) {
      const editLink = document.createElement('a');
      editLink.className = 'ab-item';
      editLink.href = page.value.editLink || `/wp-admin/post.php?post=${page.value.id}&action=edit`;
      editLink.innerText = page.value.postType?.labels.edit_item || 'Dings bearbeiten';

      const editBar = document.createElement('li');
      editBar.id = 'wp-admin-bar-edit';

      editBar.appendChild(editLink);
      $wpAdminBarRoot.appendChild(editBar);
    }
  }
};

const updateMeta = () => {
  if (!page.value) return;

  const title = page.value?.meta?.title || page.value?.title || '';
  const is404 = page.value?.is404 || true;
  const blogPublic = page.value?.blogPublic || false;
  const description = page.value?.meta?.description;
  const yoastHtml = page.value?.meta?.yoastHead?.html;

  let headerHtml = document.head.innerHTML.replace(/<!-- This site is optimized with the Yoast SEO plugin v([1-9]\d*(\.[1-9]\d*){0,3}) - https:\/\/yoast.com\/wordpress\/plugins\/seo\/ -->((.|[\n|\r|\r\n])*?)<!-- \/ Yoast SEO plugin. -->?/sg, '');

  headerHtml = headerHtml.replace(/<title>(.*?)<\/title>/sg, `<title>${title}</title>`);
  headerHtml = headerHtml.replace(/<meta name="description" content="(.*?)">/sg, `<meta name="description" content="${description}">`);

  const hasHeaderRobots = /<meta name="robots" content="(.*?)">/sg.test(headerHtml);
  const hasYoastRobots = /<meta name="robots" content="(.*?)">/sg.test(yoastHtml || '');

  if (hasHeaderRobots && hasYoastRobots) {
    headerHtml = headerHtml.replace(/<meta name="robots" content="(.*?)">/sg, '');
  } else if (hasHeaderRobots && !hasYoastRobots) {
    headerHtml = headerHtml.replace(/<meta name="robots" content="(.*?)">/sg, `<meta name="robots" content="${blogPublic ? 'index, follow' : 'noindex, nofollow'}">`);
  } else if (!hasHeaderRobots && !hasYoastRobots) {
    if (is404 || !blogPublic) {
      headerHtml += '<meta name="robots" content="noindex, follow">';
    } else {
      headerHtml += '<meta name="robots" content="index, follow">';
    }
  }

  headerHtml += yoastHtml || '';

  document.head.innerHTML = headerHtml;
};

watch(() => page.value, () => {
  MetaHandler.clearAll();

  pageContent.value = defineComponent({
    template: `<div class="page-content">${page.value?.content}</div>`,
  });

  nextTick(() => {
    show.value = true;
    setTimeout(() => {
      window.runIoEqualize();
      window.dispatchEvent(new Event('fetched'));
    }, 100);
    toTop();
  });

  const $wpAdminBar = document.querySelector('#wpadminbar');
  if ($wpAdminBar) {
    updateAdminBar();
  }

  updateMeta();
}, {
  immediate: true,
});

const closeSidebar = () => {
  store.dispatch('sidebar/close');
};

return (_ctx: any,_cache: any) => {
  const _component_BaseLoader = _resolveComponent("BaseLoader")!

  return (pageContent.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "data-page-type": pageType.value,
        onClick: closeSidebar
      }, [
        _createVNode(_Transition, { name: "page-expand" }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(pageContent.value), null, null, 512)), [
              [_vShow, status.value !== 1 && page.value]
            ])
          ]),
          _: 1
        }),
        (status.value === 1)
          ? (_openBlock(), _createBlock(_component_BaseLoader, { key: 0 }))
          : _createCommentVNode("", true)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})